<template>
  <b-card>
    <servico-list
      ref="servicoList"
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :filtros="filtros"
      filtrar-por-ativo
      @removerItem="remover($event)"
    >
      <template slot="botoes-adicionais">
        <b-button
          variant="success btn-sm"
          class="mx-1"
          @click="exportar"
        >
          Exportar
        </b-button>
        <filtro-adicional
          v-if="carregado"
          :value="valueFiltro"
          @aplicar="maisFiltros($event)"
        />
      </template>
      <template
        slot="celula-personalizada"
        slot-scope="{props}"
      >
        <span v-if="props.column.label === 'Rodízio'">
          {{ props.row.participaRodizioEquipe ? 'Sim' : 'Não' }}
        </span>
      </template>
    </servico-list>
  </b-card>
</template>

<style lang="scss">
</style>

<script>
import api from '@/app-modulo/comuns/servico/shared/services/api'

export default {
  name: 'ServicoVisualizacao',
  components: {
    ServicoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
    FiltroAdicional: () => import('@/app-modulo/comuns/servico/shared/components/filtro-adicional/FiltroAdicional.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Nome', field: 'nome', type: 'personalizada', showActive: true, editable: true,
        },
        { label: 'Departamento', field: 'departamentoNome' },
        {
          label: 'valor auditar', field: 'valorAuditar', formatFn: value => parseFloat(value.toFixed(2)).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency', minimumFractionDigits: 2 }),
        },
        { label: 'Periodicidade', field: 'periodicidade' },
        { label: 'Rodízio', field: 'participaRodizioEquipe', type: 'personalizada' },
      ],
      filtros: [{ colunas: ['Nome', 'Rodizio', 'DepartamentoNome', 'Periodicidade'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
      valueFiltro: {
        tributacoes: null,
        atividades: null,
        buscaVinculoOmie: [],
        departamentos: null,
      },
      carregado: false,
    }
  },
  methods: {
    maisFiltros(filtros) {
      this.valueFiltro = filtros
      this.$refs.servicoList.montarGrid()
    },
    carregar(page, pageSize, filtro) {
      this.carregado = true
      const filtros = {
        filtroPricipal: filtro,
        filtrosAdicionais: {
          ...this.valueFiltro,
          departamentos: (this.valueFiltro.departamentos || []).map(departamento => departamento.id),
        },
      }
      return api.getServicos(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-servico' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-servico', params: { id: value.id } })
    },
    remover(itens) {
      if (itens && itens.length === 1) {
        return new Promise((resolve, reject) => {
          api.verificaVinculo(itens[0].id)
            .then(payload => {
              if (payload.data) {
                this.$swal({
                  text: 'Não é permitido realizar essa exclusão, pois este registro está associado em campos obrigatórios de outros cadastros.',
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonText: 'OK',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                })
                  .then(() => {
                    reject()
                  })
              } else {
                api.deleteServico(itens[0].id)
                  .then(() => {
                    resolve(false)
                  })
                  .catch(err => {
                    reject(err)
                  })
              }
            })
            .catch(err => {
              reject(err)
            })
        })
      }

      const idList = itens.map(map => map.id)
      return api.deleteAll({ identificadores: idList })
    },
    async exportar() {
      // Juntando as informações dos filtros para o backend devolver o arquivo filtrado conforme o usuário setou na tabela
      const servidorParametros = this.$refs.servicoList?.servidorParams

      const filtros = {
        busca: servidorParametros?.filtros?.[0]?.valor ?? '',
        inativo: servidorParametros?.filtros?.[1]?.label === 'Inativo',
        atividades: (this.valueFiltro.atividades || []).map(atividade => atividade.id),
        buscaVinculoOmie: (this.valueFiltro.buscaVinculoOmie || []).map(vinculoOmie => vinculoOmie.id),
        departamentos: (this.valueFiltro.departamentos || []).map(departamento => departamento.id),
        tributacoes: (this.valueFiltro.tributacoes || []).map(tributacoes => tributacoes.id),
      }

      try {
        const response = await api.exportarServicos(filtros)
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'servicos.xlsx'
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        this.$swal({
          text: 'Erro ao exportar os dados.',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
      }
    },
  },
}
</script>
